import { listResponseSchema } from '@/core/types/ListResponse.ts'
import {
  clientDetailSchema,
  clientSchema
} from '@/modules/sales/clients/types/Client.ts'
import { responseSchema } from '@/core/types/Response.ts'
import { z } from 'zod'
import {
  articleDetailDtoSchema,
  articleSchema,
  assignArticleAppleSchema,
  assignArticleMotorSchema,
  assignArticleSchema
} from '@/modules/sales/clients/types/Article.ts'
import { modificationHistorySchema } from '@/modules/sales/clients/types/ModificationHistory.ts'
import { quoteSchema } from '@/modules/sales/clients/types/Quote.ts'
import { activitySummarySchema } from '@/modules/sales/clients/types/ActivitySummary.ts'

// client
export const clientListResponseSchema = listResponseSchema(clientSchema)
export const clientResponseSchema = responseSchema(clientDetailSchema)
export type ClientListResponse = z.infer<typeof clientListResponseSchema>

// article
export const articleListResponseSchema = listResponseSchema(articleSchema)
export const articleResponseSchema = responseSchema(articleDetailDtoSchema)
export type ArticleListResponse = z.infer<typeof articleListResponseSchema>

// article
export const quoteListResponseSchema = listResponseSchema(quoteSchema)
export type QuoteListResponse = z.infer<typeof quoteListResponseSchema>

// assigned article
export const assignedArticleResponseSchema = responseSchema(assignArticleSchema)
export type AssignedArticleListResponse = z.infer<
  typeof assignedArticleResponseSchema
>

// assigned article apple
export const assignedArticleAppleResponseSchema = responseSchema(
  assignArticleAppleSchema
)
export type AssignedArticleAppleListResponse = z.infer<
  typeof assignedArticleAppleResponseSchema
>

// assigned motor
export const assignedArticleMotorResponseSchema = responseSchema(
  assignArticleMotorSchema
)
export type AssignedArticleMotorListResponse = z.infer<
  typeof assignedArticleMotorResponseSchema
>

// modification history
export const modificationHistoryListResponseSchema = listResponseSchema(
  modificationHistorySchema
)
export type ModificationHistoryListResponse = z.infer<
  typeof modificationHistoryListResponseSchema
>

// verification email code
export const verifyEmailCodeResponseSchema = responseSchema(
  z.object({
    email: z.string().email(),
    clientUuid: z.string().nonempty(),
    clientId: z.number()
  })
)
export type VerifyEmailCodeSchemaResponse = z.infer<
  typeof verifyEmailCodeResponseSchema
>
export const verifyEmailExistenceResponseSchema = responseSchema(
  z.object({
    exist: z.boolean()
  })
)
export type VerifyEmailExistenceSchemaResponse = z.infer<
  typeof verifyEmailExistenceResponseSchema
>
export const verifyPhoneExistenceResponseSchema = responseSchema(
  z.object({
    exist: z.boolean()
  })
)
export type VerifyPhoneExistenceSchemaResponse = z.infer<
  typeof verifyPhoneExistenceResponseSchema
>

// activity summary
export const activitySummaryResponseSchema = responseSchema(
  activitySummarySchema
)
export type ActivitySummaryResponse = z.infer<
  typeof activitySummaryResponseSchema
>

// get credit from birthDate
const getCreditFromBirthDateSchema = z.object({
  credit: z.number()
})
export const getCreditFromBirthDateResponseSchema = responseSchema(
  getCreditFromBirthDateSchema
)
export type GetCreditFromBirthDateResponse = z.infer<
  typeof getCreditFromBirthDateResponseSchema
>
